class APIS {
	apis() {
		return {
			clearCache: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/clear/cache'
            },
		};
	}
}

export default new APIS();
